import { DEFAULT_DATE_FORMAT } from "@/constants";
import {
  CreateProjectSchedule,
  CreateProjectScheduleForm,
} from "@/types/projectSchedule";
import { eachDayOfInterval, format, getWeek } from "date-fns";

export const generateScheduleSelectedDays = ({
  date_start,
  date_end,
  weekdays,
  every_second_week,
}: {
  date_start: string;
  date_end: string;
  weekdays: CreateProjectScheduleForm["weekdays"];
  every_second_week: boolean;
}): CreateProjectSchedule["dates"] => {
  // Convert date_start and date_end to Date objects
  const startDate = new Date(date_start);
  const endDate = new Date(date_end);

  // Generate array of days between start and end date
  const dateInterval = eachDayOfInterval({
    start: startDate,
    end: endDate,
  });

  // Get the week number of the start date to use as reference
  const startWeek = getWeek(startDate);

  const selectedDays: CreateProjectSchedule["dates"] = [];
  // Process each day in the interval
  dateInterval.forEach((date) => {
    const dayName = format(date, "EEEEEE");
    const isDaySelected = weekdays[dayName as keyof typeof weekdays];

    // Calculate if this week should be included based on everySecondWeek
    const currentWeek = getWeek(date);
    const weekDifference = currentWeek - startWeek;
    const isSelectedWeek = !every_second_week || weekDifference % 2 === 0;

    if (isDaySelected && isSelectedWeek) {
      selectedDays.push(format(date, DEFAULT_DATE_FORMAT));
    }
  });

  return selectedDays;
};
